import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import React from "react";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import whiteBg from "../Images/Frame.png";
import brandingnew from "../Images/Graphics PNG/brand.png";
import graphicManagementservice from "../Images/Graphics PNG/graphicManagementservice.png";
import seo from "../Images/Graphics PNG/seo.png";
import socialmarketingservice1 from "../Images/Graphics PNG/socialmarketingservice1.png";
import vid2 from "../Images/Graphics PNG/vid2.png";
import work from "../Images/Graphics PNG/work.png";
import brandingIcon from "../Images/serviceIcons/Branding.png";
import seoIcon from "../Images/serviceIcons/Seo.png";
import socialMediaIcon from "../Images/serviceIcons/social media management.png";
import socialMediaMarketingIcon from "../Images/serviceIcons/social media marketing.png";
import videoEditingIcon from "../Images/serviceIcons/Video Editing.png";
import webDevelopmentIcon from "../Images/serviceIcons/Web Development.png";
// Assume you have larger images for each service
const serviceLargeImages = {
  socialMedia: graphicManagementservice,
  socialMediaMarketing: socialmarketingservice1,
  branding: brandingnew,
  seo: seo,
  videoEditing: vid2,
  webDevelopment: work,
};

const services = [
  {
    icon: socialMediaMarketingIcon,
    name: "Social Media Marketing",
    description:
      "Boost your brand's reach with customized digital marketing and targeted social media campaigns. We connect you with the right audience, driving engagement and conversions.",
    link: "/services/SocialMediaMarketing",
    largeImage: serviceLargeImages.socialMediaMarketing,
  },
  {
    icon: webDevelopmentIcon,
    name: "Web Development",
    description:
      "Design and develop stunning, user-friendly websites that reflect your brand. We build websites that not only look great but also drive conversions.",
    link: "/services/WebDevelopment",
    largeImage: serviceLargeImages.webDevelopment,
  },
  {
    icon: videoEditingIcon,
    name: "Video Editing",
    description:
      "Transform your raw footage into captivating visual stories. Our video editing services enhance your content, making it more engaging and shareable.",
    link: "/services/videoEditing",
    largeImage: serviceLargeImages.videoEditing,
  },
  {
    icon: brandingIcon,
    name: "Branding",
    description:
      "Create a brand identity that resonates with your audience. Our branding services craft unique, memorable experiences that set you apart in the market.",
    link: "/services/graphicDesign",
    largeImage: serviceLargeImages.branding,
  },

  {
    icon: socialMediaIcon,
    name: "Social Media Management",
    description:
      "Optimize your online presence with consistent social media management. We handle content, engagement, and analytics to grow your community and enhance your brand.",
    link: "/services/SocialMediaManagement",
    largeImage: serviceLargeImages.socialMedia,
  },

  {
    icon: seoIcon,
    name: "SEO",
    description:
      "Boost your website's visibility with our expert SEO services. We ensure you rank higher, attract quality traffic, and convert visitors into loyal customers.",
    link: "/services/SEO",
    largeImage: serviceLargeImages.seo,
  },
];

const CustomButton = ({ href, children }) => (
  <a
    href={href}
    className="inline-block px-5 z-30 py-3 bg-teal-500 bg-opacity-70 border-teal-50 border rounded-md text-white relative font-medium after:-z-20 hover:text-white after:absolute after:h-1 after:w-1 after:bg-teal-300 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-lg"
  >
    {children}
  </a>
);

const ServiceHeroSection = ({ service, index }) => {
  const isEven = index % 2 === 0;

  const slideVariants = {
    hidden: {
      opacity: 0,
      x: isEven ? 100 : -100,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        type: "spring",
        damping: 20,
        stiffness: 20,
        delay: 0.8,
      },
    },
  };

  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={slideVariants}
      className={`flex flex-col ${
        isEven ? "md:flex-row-reverse" : "md:flex-row"
      } items-center  py-10 px-4 md:px-10 lg:px-10`}
      style={{ willChange: "transform, opacity" }} // Add will-change
    >
      <div className="w-full md:w-1/2 mb-10 md:mb-0 flex justify-center ">
        <motion.img
          src={service.largeImage}
          alt={service.name}
          className="w-full h-auto p-5 lg:p-10"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 300 }}
        />
      </div>
      <div
        className={`w-full md:w-1/2 ${
          isEven ? "md:pl-10" : "md:pr-10"
        } lg:p-10 md:p-10 p-3 flex flex-col items-center md:items-start text-center md:text-left`}
      >
        <motion.div
          className="flex items-center mb-6 justify-center md:justify-start w-full"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-teal-400">
            {service.name}
          </h2>
        </motion.div>
        <motion.p
          className="text-lg text-gray-700 mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
        >
          {service.description}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7 }}
        >
          <CustomButton href={service.link}>
            Show Details <ArrowRight className="ml-2 w-5 h-5 inline" />
          </CustomButton>
        </motion.div>
      </div>
    </motion.section>
  );
};

const ServicesPage = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${whiteBg})`,
        backgroundSize: "cover",
        backgroundPosition: "top left",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <Header />
      <div className="max-w-7xl mx-8 md:mx-10 lg:mx-16 xl:mx-auto bg-transparent text-teal-900 font-normal ">
        <div className="container mx-auto">
          <motion.h1
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-2xl md:text-3xl lg:text-4xl font-bold text-center pt-2 md:pt-2 lg:pt-10 text-teal-600"
          >
            We Provide The Best Services
          </motion.h1>

          {services.map((service, index) => (
            <ServiceHeroSection key={index} service={service} index={index} />
          ))}

          {/* Contact Section */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8 }}
            className="bg-white mb-10 py-10 px-4 md:px-10 lg:px-20 mt-20 rounded-lg shadow-lg"
          >
            <h2 className="text-3xl font-bold mb-6 text-center text-teal-600">
              Get in Touch
            </h2>
            <p className="text-lg text-gray-700 mb-8 text-center max-w-2xl mx-auto">
              We would love to hear from you! Whether you have a question,
              feedback, or just want to chat, feel free to reach out to us. Our
              team is here to assist you.
            </p>
            <div className="text-center">
              <motion.a
                href="/contact"
                className="inline-flex items-center px-8 py-4 bg-teal-500 text-white font-semibold rounded-lg hover:bg-teal-600 transition-colors duration-300 text-lg"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Contact Us
                <ArrowRight className="ml-2 w-6 h-6" />
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ServicesPage;
